import { gql } from '@apollo/client';

export const CREATE_DRIVER_GROUP = gql`
  mutation CreateDriverGroup($name: String!, $description: String, $userIds: [Int!]) {
    createDriverGroup(name: $name, description: $description, userIds: $userIds) {
      id
      name
      description
    }
  }
`;

export const UPDATE_DRIVER_GROUP = gql`
  mutation UpdateDriverGroup($id: Int!, $name: String, $description: String) {
    updateDriverGroup(id: $id, name: $name, description: $description) {
      id
      name
      description
    }
  }
`;

export const DELETE_DRIVER_GROUP = gql`
  mutation DeleteDriverGroup($id: Int!) {
    deleteDriverGroup(id: $id)
  }
`;

export const ADD_DRIVER_TO_GROUP = gql`
  mutation AddDriverToGroup($groupId: Int!, $userId: Int!) {
    addDriverToGroup(groupId: $groupId, userId: $userId) {
      groupId
      userId
    }
  }
`;

export const REMOVE_DRIVER_FROM_GROUP = gql`
  mutation RemoveDriverFromGroup($groupId: Int!, $userId: Int!) {
    removeDriverFromGroup(groupId: $groupId, userId: $userId)
  }
`;
